var _PRODUCT_TYPES, _PRODUCT_TYPES_API, _PRODUCT_TYPES_NAME, _PRODUCT_TYPES_TABLE_;
var PASS_TYPE = 'pass';
var SUBSCRIPTION_TYPE = 'subscription';
var PLEDGE_TYPE = 'pledge';
var TRIAL_TYPE = 'trial';
var INDIVIDUAL_SUBSCRIPTION_TYPE = 'individual';
var GROUP_SUBSCRIPTION_TYPE = 'group';
var DONATION_SUGGESTIONS = 'donation';

// used to classify the parent url of each product type
(_PRODUCT_TYPES = {}, _PRODUCT_TYPES[PASS_TYPE] = 'passes', _PRODUCT_TYPES[INDIVIDUAL_SUBSCRIPTION_TYPE] = 'subscriptions', _PRODUCT_TYPES[GROUP_SUBSCRIPTION_TYPE] = 'subscriptions', _PRODUCT_TYPES[DONATION_SUGGESTIONS] = 'donationboxes', _PRODUCT_TYPES);

// when products are submitted to api, it expects these types
(_PRODUCT_TYPES_API = {}, _PRODUCT_TYPES_API[PASS_TYPE] = 'pass', _PRODUCT_TYPES_API[INDIVIDUAL_SUBSCRIPTION_TYPE] = 'subscription', _PRODUCT_TYPES_API[GROUP_SUBSCRIPTION_TYPE] = 'group', _PRODUCT_TYPES_API[DONATION_SUGGESTIONS] = 'donation', _PRODUCT_TYPES_API);
(_PRODUCT_TYPES_NAME = {}, _PRODUCT_TYPES_NAME[PASS_TYPE] = 'Pass', _PRODUCT_TYPES_NAME[INDIVIDUAL_SUBSCRIPTION_TYPE] = 'Individual Subscription', _PRODUCT_TYPES_NAME[GROUP_SUBSCRIPTION_TYPE] = 'Group Subscription', _PRODUCT_TYPES_NAME[DONATION_SUGGESTIONS] = 'Donation Box', _PRODUCT_TYPES_NAME);
(_PRODUCT_TYPES_TABLE_ = {}, _PRODUCT_TYPES_TABLE_[SUBSCRIPTION_TYPE] = 'Individual', _PRODUCT_TYPES_TABLE_[GROUP_SUBSCRIPTION_TYPE] = 'Group', _PRODUCT_TYPES_TABLE_);

export { DONATION_SUGGESTIONS, GROUP_SUBSCRIPTION_TYPE, INDIVIDUAL_SUBSCRIPTION_TYPE, PASS_TYPE, PLEDGE_TYPE, SUBSCRIPTION_TYPE, TRIAL_TYPE };
//# sourceMappingURL=productEdit.js.map
